(ns frontend.actions.feedback
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->create-feedback [data on-success! on-error!]
  (-> (conn/sendp! :feedback/create
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->send [data on-success! on-error!]
  (-> (conn/sendp! :feedback/send
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->cancel [feedback-id on-success! on-error!]
  (-> (conn/sendp! :feedback/cancel
                   {:feedback-id feedback-id})
      (p/then on-success!)
      (p/catch on-error!)))
